import React from 'react';
import { Popover } from '@abyss/web/ui/Popover';
import { RiskScoresPopoverBreakdownProps } from '../../../types';

export const RiskScoresPopoverBreakdown: React.FC<RiskScoresPopoverBreakdownProps> =
  ({ signals, value }) => {
    const sortedSignals = signals;

    return (
      <Popover
        content={
          <div className="riskScoresPopoverContent">
            <div className="popover-title">Signal</div>
            <div className="popover-signals">
              {sortedSignals.map((signal) => {
                return (
                  <div key={signal.id} className="popover-signal-row">
                    <span className="signal-name">{signal.name}</span>
                    <span className="signal-weight">{signal.weight}</span>
                  </div>
                );
              })}
            </div>
          </div>
        }
        position="top"
      >
        <span className="clickable-value">{value}</span>
      </Popover>
    );
  };
